import { render, staticRenderFns } from "./SidebarNavDropdown.vue?vue&type=template&id=0d531228"
import script from "./SidebarNavDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarNavDropdown.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavDropdown.vue?vue&type=style&index=0&id=0d531228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports